/**
 *
 * BIGTINCAN - CONFIDENTIAL
 *
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of BigTinCan Mobile Pty Ltd and its suppliers,
 * if any. The intellectual and technical concepts contained herein are proprietary to BigTinCan Mobile Pty Ltd and its
 * suppliers and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or reproduction of this material is strictly forbidden unless prior
 * written permission is obtained from BigTinCan Mobile Pty Ltd.
 *
 * @package gs-dxc-wws
 * @copyright 2010-2020 BigTinCan Mobile Pty Ltd
 * @author Hans C Yustiawan <hans.yustiawan@bigtincan.com>
 */

import { AxiosRequestConfig, AxiosInstance } from 'axios';
import { BrowserStorageKey } from '../constant/storage';
import { HttpStatusCode } from '../constant/httpStatusCode';
import store from '../store/configuredStore';
import { getNewToken } from '../store/Login/actions';


type cacheType = {
  resolve: (value?: unknown) => void;
  reject: (reason: any) => void;
  url: string;
};
const cacheRequest: cacheType[] = [];


export const getNewConfig = (config: AxiosRequestConfig) => {

  let token = localStorage.getItem(BrowserStorageKey.ACCESS_TOKEN);
  if (config && config.url && config.url.indexOf('graph') >= 0) {
    token = localStorage.getItem('graph_token');
  }
  return {
    ...config,
    headers: {
      ...config.headers,
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  };
};

export const authenticationInterceptor = (
  client: AxiosInstance,
  error: any,
) => {
  if (+error.message === HttpStatusCode.REQUEST_ABORTED) {
    return Promise.reject(error);
  }
  const {
    response: { config, status },
  } = error;
  // if it is unauthorized and not an attempt to refresh access token
  if (
    status
    && status === HttpStatusCode.UNAUTHORIZED
    && config
    && config.url !== '/connect/refresh'
  ) {
    // if one or more request is being cached already or login is in progress then cache current request to the same cache.
    if (cacheRequest.length > 0 || store.getState().login.loginProgress) {
      return new Promise((resolve, reject) => {
        cacheRequest.push({ resolve, reject, url: config.url });
      })
        .then(() => client(getNewConfig(config)))
        .catch((err) => Promise.reject(err));
    }

    // else then attempt to refresh token.
    return new Promise((resolve, reject) => {
      const refreshToken = async () => {
        await store.dispatch(getNewToken() as any);
        if (store.getState().login.loginSuccess) {
          // if refresh successful then redo all the cached requests.
          cacheRequest.forEach((item) => item.resolve());
        }
        cacheRequest.splice(0, cacheRequest.length);
      };

      cacheRequest.push({ resolve, reject, url: config.url });
      refreshToken();
    })
      .then(() => client(getNewConfig(config)))
      .catch((err) => Promise.reject(err));
  }
  if (
    status === HttpStatusCode.UNAUTHORIZED
    && (config.url === '/connect/refresh')
  ) {
    cacheRequest.forEach((item) => item.reject(error));
    cacheRequest.splice(0, cacheRequest.length);
  }
  if (
    status === HttpStatusCode.UNAUTHORIZED
  ) {
    window.location.href = "/";
  }
  return Promise.reject(error);
};
